import React from 'react'
import TextField from '@material-ui/core/TextField';
import Select from 'react-select';
import star_icon from '../../assets/images/icons/star-icon.png'




const HorizontalTextinput = (props)=>{
    return(
        <div className="horizontal-text-input-container">
            <div className="horizontal-text-input-header">
                <span className="general-span-text-none-auto-small">{props.title}</span>
                {props.required && <div>
                        <img src={star_icon}/>
                    </div>}
            </div>
            <div className="dashboard-textfield-input mt-2" style={{backgroundColor: '#FAFAFA'}}>
                {!props.isSelect ?<TextField 
                    id="outlined-basic" 
                    label="" 
                    variant="outlined"
                    style={{width: '95%'}}
                    size="small"
                    onChange={props.handleChange}
                    value={props.value}
                    disabled={props.disabled}
                    type={props.type}
                    placeholder={props.placeholder}
                    error={props.error}
                    helperText={props.helperText}
                    onBlur={props.onBlur}
                     />:
                     <Select
                        value={props.selectedOption}
                        onChange={props.handleChange}
                        options={props.options}
                        className="vertical-select-field"
                        type={props.type}

                 />
                }
            </div>
        </div>

    )
}

export default HorizontalTextinput